export default "__VITE_ASSET__Gfuh$2u8__"